export default __webpack_public_path__ + "static/media/gowda.d816a5cc.JPG";